
<div>
  <div class="col-md-12 col-lg-12">
    <div [@openClose]="!isOpen ? 'open' : 'closed'">
      <div class="col-sm-3 col-md-3"><h4><b>{{ "pages.createReceiptPage.commodityPage.goodsValue" | translate }}</b></h4></div>
      <div class="col-sm-3 col-md-3"><h4>{{goodsValue}}</h4></div>
      <div class="col-sm-3 col-md-4"><h4 class="change {{enableChange? '':'disabled'}}" (click)="change()">{{ "common.change" | translate }}</h4></div>
      <div class="col-sm-4 col-md-3"><h4><b>{{ "pages.createReceiptPage.commodityPage.commodity" | translate }}</b></h4></div>
      <div class="col-sm-6 col-md-6"><h4>{{selectedValue.key}}</h4></div>
      <div class="col-sm-4 col-md-4" *ngIf="selectedValue.value==14"><h4><b>{{ "pages.createReceiptPage.commodityPage.commodityDescription" | translate }}</b></h4></div>
      <div class="col-sm-8 col-md-8" *ngIf="selectedValue.value==14"><h4>{{otherCommodityTxt}}</h4></div>
    </div>
  </div>
</div>
<div [@openClose]="isOpen ? 'open' : 'closed'">
  <div class="col-sm-12 col-md-12 mrgin-lft"><h4><b>{{ "pages.createReceiptPage.commodityPage.goodsValueAndCommodityDescription" | translate }}</b></h4></div>
</div>
<div [@openClose]="isOpen ? 'open' : 'closed'" *ngIf="notIsCommodity">
  <div class="row mrgin25p">
    <div class="col-md-4 col-sm-6">
      <!--<label>Goods Value</label>-->
      <div class="form-group">
        <label>{{ "pages.createReceiptPage.commodityPage.value" | translate }}</label>
        <div class="input-group">
          <div class="inner-addon right-addon">
            <div class="row">
              <div class="col-md-8 col-sm-8 col-xs-8" style="padding-right:0">
                <input type="text" class="form-control"
                       [(ngModel)]="goodsValue"
                         (blur)="checkRequiredField()"
                       style="border-top-right-radius: 0;border-bottom-right-radius: 0;" />
                <span [innerHtml]="validatorObject.goodsValue.message"></span>
              </div>
              <div class="col-md-4 col-sm-4 col-xs-4" style="padding-left:0">
                <select class="form-control curr-menu" [(ngModel)]="branchCurrencyCode">
                  <option *ngFor="let currency of currenceis" [selected]="currency.value==branchCurrencyCode">{{currency.value}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 col-sm-5">
      <div class="dropdown {{showDdl ? 'open' : ''}}">
        <label>{{ "pages.createReceiptPage.commodityPage.commodity" | translate }}</label>
        <div class="inner-addon right-addon">
          <i class="glyphicon armx-sort"></i>
          <input type="text" class="form-control" input-Foucs (onInputFocus)="triggerFoucs($event)" (focus)="search($event)" placeholder="search" (input)="search($event)" [(ngModel)]="searchTerm"  (blur)="checkRequiredField()"/>
        </div>
        <ul class="dropdown-menu com-drop" *ngIf="showCommodityList">
          <li *ngFor="let item of tempContent; index as i" class="{{i==arrowkeyLocation? 'active' :''}}"><a (click)="selectCommodityDDL(item)">{{item.key}}</a></li>
        </ul>
      </div>
      <span [innerHtml]="validatorObject.selectedCommodity.message"></span>
    </div>
    <div class="col-md-4 col-sm-10" *ngIf="otherCommodity">
      <label>{{ "common.description" | translate }}</label>
      <input type="text" class="form-control" placeholder="Commodity Description" [(ngModel)]="otherCommodityTxt" (blur)="checkOtherComText()"/>
      <span *ngIf="!validOtherText" style="display:inherit;color:red;font-size:12px">{{ "pages.createReceiptPage.commodityPage.descValidationMsg" | translate }}</span>
    </div>
  </div>
  <div class="col-md-8">
    <div class="form-group">
      <button class="btn btn-primary" (click)="nextCommodity()">{{ "common.next" | translate }}</button>
      <br />
    </div>
  </div>
</div>



